import { computed } from 'vue';

import { useDict, useFischer } from '@/composables/fischerPlugin';

export const useSalesforceInformation = () => {
  const fischer = useFischer();
  const dict = useDict();

  const salesforce = fischer.user.getSalesforce();

  const typeDisplay = computed<string>(() => {
    const value = salesforce?.documentType || '';
    if (value === 'quote') {
      return dict.get('salesforce.Document-Types.Quote');
    }
    if (value === 'order') {
      return dict.get('salesforce.Document-Types.Order');
    }
    return value;
  });

  const erpTypeDisplay = computed<string>(() => {
    const value = salesforce?.cart?.erpOrderType || '';
    if (value === 'ZOA') {
      return dict.get('salesforce.Erp-Types.ZOA') || value;
    }
    return value;
  });

  const deliveryDisplay = computed<string>(() => {
    const value = salesforce?.cart?.completeDelivery;
    return dict.get(value ? 'salesforce.Complete-Delivery' : 'salesforce.Partial-Delivery');
  });

  const opportunityNr = computed<string>(() => {
    return salesforce?.salesforceOrderId || '';
  });

  const designation = computed<string>(() => {
    return salesforce?.cart?.salesforceOpportunityName || '';
  });

  return {
    salesforce,
    typeDisplay,
    deliveryDisplay,
    opportunityNr,
    designation,
    erpTypeDisplay,
  };
};
